import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import {
  chargeBearer,
  checkoutMethodsOrders,
  failedPaymentResolutionTypes,
  gateway_recommendation_type,
} from "../../enums";
import {
  useAccountSettings,
  useHookForm,
  useMerchantApiMutation,
} from "../../hooks";
import { ICheckoutAndPaymentLinkSettings } from "../../interfaces-and-types";
import { globalHandlerUtils } from "../../utils";
import { checkoutValidationSchema } from "./validationSchema";

import { View } from "./View";

export const CheckoutAndPaymentLinks = () => {
  const navigate = useNavigate();

  const {
    // isLoading: isLoadingAccountSettings,
    isSuccess: isSuccessAccountSettings,
    data: accountSettings,
    refreshRemoteData: refreshAccountSettings,
  } = useAccountSettings();

  useEffect(() => {
    accountSettings && reset(accountSettings);
  }, []);

  useEffect(() => {
    if (isSuccessAccountSettings) {
      // console.log("resetting the form...");
      accountSettings && reset(accountSettings);
    }
  }, [isSuccessAccountSettings]);

  const initialFormValues: ICheckoutAndPaymentLinkSettings = {
    bearer: chargeBearer.customer,
    display_links_to_your_terms_and_policies: false,
    display_support_contact_info: false,
    include_payment_gateways_and_methods: false,
    checkout_methods_order: checkoutMethodsOrders.gateways,
    gateway_recommendation_type: gateway_recommendation_type.region,
    failed_payment_auto_resolution_type:
      failedPaymentResolutionTypes.instantRefund,
    delayed_refund_duration_hours: 24,
    instant_refund_incomplete_amount_threshold_percentage: 100,
    // ...accountSettings,
  };

  const { isSuccess: isSuccessSaveSettings, mutate: saveSettings } =
    useMerchantApiMutation<
      ICheckoutAndPaymentLinkSettings,
      ICheckoutAndPaymentLinkSettings
    >("saveCheckoutAndPaymentLinksSettings").usePutMutation;

  const handleApiSubmit = (data: ICheckoutAndPaymentLinkSettings) => {
    saveSettings(data);
  };

  const handleError = (errors: any) => globalHandlerUtils.handleError(errors);

  const { onFormSubmit, isDirty, errors, register, reset, setValue, watch } =
    useHookForm({
      initialFormValues,
      validationSchema: checkoutValidationSchema,
      onValid: handleApiSubmit,
      onInvalid: handleError,
    });

  useEffect(() => {
    if (isSuccessSaveSettings) {
      refreshAccountSettings();
    }
  }, [isSuccessSaveSettings]);

  const show_payment_providersFormValue = watch(
    "include_payment_gateways_and_methods"
  );

  const onToggleShowPaymentProviders = () =>
    setValue(
      "include_payment_gateways_and_methods",
      !show_payment_providersFormValue
    );

  const goBack = () => navigate("/settings");

  const formValues = watch();

  return (
    <View
      show_payment_providersFormValue={show_payment_providersFormValue}
      onToggleShowPaymentProviders={onToggleShowPaymentProviders}
      goBack={goBack}
      isDirty={isDirty}
      formValues={formValues}
      handleSubmit={onFormSubmit}
      register={register}
      errors={errors}
    />
  );
};
